var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"copyright"},[_vm._v(" 【免责声明】本公司力求数据的准确性，如有错漏请以上市公司公告原文为准。本公司不因对该资料产生或引起的任何损失承担任何责任。 大智慧数据中心制作，如有疑问请拨打021-20219988-39108 ")])}
var staticRenderFns = []

export { render, staticRenderFns }